export enum AlertFiled {
  ZeroDelivery = 'zero-delivery',
  MisalignedSchedule = 'misaligned-schedule',
  InventoryBlock = 'inventory-block',
  LineItem = 'line-item',
  OmsNotification = 'oms-notification',
  InvalidPublisher = 'invalid-publisher',
  InvalidCountry = 'invalid-country',
  infoAdSequence = 'info-ad-sequence',
  StaqError = 'staq-error',
}

export const FAILURE_CODES_TEMPLATE_VARIABLE = '{failureCodes}';
export const DEFAULT_FAILURE_CODE_SEPARATOR = '\n• ';

export const ALERT_MESSAGES: Partial<Record<AlertFiled, string>> = {
  [AlertFiled.MisalignedSchedule]: 'This ad has a misaligned schedule.',
  [AlertFiled.InvalidPublisher]:
    'Ad contains invalid publisher. Update publisher targeting on your ad to match the line item publisher target or' +
    ' deactivate the ad.',
  [AlertFiled.InvalidCountry]:
    'Ad contains invalid country targeting. Update country targeting on your ad consistent with the line item' +
    ' countries or deactivate the ad.',
  [AlertFiled.infoAdSequence]:
    'Pod and Slot targets will be ignored when the ad is in a Sequence. Configure these in the Sequences page.',
  [AlertFiled.LineItem]: 'Ad contains unlinked Line Item.',
  [AlertFiled.InventoryBlock]: 'This ad has an inventory block.',
  [AlertFiled.StaqError]: `A data validation error exists on this line:\n• ${FAILURE_CODES_TEMPLATE_VARIABLE}.\nThe automation algorithm continues to set the automated buffer based on the last known valid data or a default value.`,
};
